module.exports = __webpack_public_path__ + "static/media/pepinos.14207d30.png";